module.exports = __webpack_public_path__ + "img/faile_icon1.dc536d24.png";